import * as React from "react"
import { SkipNavContent, SkipNavLink } from "./skip-nav"
import { Header } from "./header"
import { Footer } from "./footer"
import { Seo } from "./seo"
import { SideBar } from "./sidebar"

export function Layout({ children }) {
  return (
    <div>
      <Seo />
      <SkipNavLink />
      <Header />
      <SideBar />
      <SkipNavContent>{children}</SkipNavContent>
      <Footer />
    </div>
  )
}
